import React from "react";
import "./Connect.css";

const Connect: React.FC = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "+9779749411747";
    const message = "Hello! I'd like to connect with you.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="connect-page">
      {/* Hero Section */}
      <section className="connect-hero">
        <div className="container">
          <div className="connect-hero-content">
            <h1 className="connect-hero-title">
              Let's <span className="highlight">Connect</span>
            </h1>
            <p className="connect-hero-description">
              I'm always open to new opportunities, collaborations, and interesting conversations. 
              Feel free to reach out through any of these platforms or drop me a message directly.
            </p>
          </div>
        </div>
      </section>

      {/* Social Links Section */}
      <section className="social-links-section">
        <div className="container">
          <div className="social-links-grid">
            {/* GitHub */}
            <a 
              href="https://github.com/joras-droid" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link-card github"
            >
              <div className="social-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </div>
              <div className="social-content">
                <h3>GitHub</h3>
                <p>Check out my projects and contributions</p>
                <span className="social-handle">@joras-droid</span>
              </div>
              <div className="social-arrow">→</div>
            </a>

            {/* LinkedIn */}
            <a 
              href="https://www.linkedin.com/in/nirajan-bh/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link-card linkedin"
            >
              <div className="social-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </div>
              <div className="social-content">
                <h3>LinkedIn</h3>
                <p>Connect professionally and view my experience</p>
                <span className="social-handle">nirajan-bh</span>
              </div>
              <div className="social-arrow">→</div>
            </a>

            {/* Gmail */}
            <a
              href="mailto:nirajanbhattarai12345@gmail.com"
              className="social-link-card gmail"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.364V5.457c0-.904.732-1.636 1.636-1.636h3.819V11.73L12 6.64l6.545 5.09V3.821h3.819A1.636 1.636 0 0 1 24 5.457z"/>
                </svg>
              </div>
              <div className="social-content">
                <h3>Email</h3>
                <p>Send me a direct message</p>
                <span className="social-handle">nirajanbhattarai12345@gmail.com</span>
              </div>
              <div className="social-arrow">→</div>
            </a>

            {/* WhatsApp */}
            <button 
              onClick={handleWhatsAppClick}
              className="social-link-card whatsapp"
            >
              <div className="social-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
              </div>
              <div className="social-content">
                <h3>WhatsApp</h3>
                <p>Chat with me directly</p>
                <span className="social-handle">+977 9749411747</span>
              </div>
              <div className="social-arrow">→</div>
            </button>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      {/* <section className="contact-form-section">
        <div className="container">
          <div className="contact-form-content">
            <h2>Send me a message</h2>
            <p>Have a project in mind or want to collaborate? I'd love to hear from you!</p>
            
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input type="text" id="name" name="name" placeholder="Your name" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" name="email" placeholder="your.email@example.com" />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" name="subject" placeholder="What's this about?" />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows={5} placeholder="Tell me more about your project or inquiry..."></textarea>
              </div>
              
              <button type="submit" className="submit-btn">
                <span>Send Message</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Connect;
